import ceil from 'lodash/ceil';
import { convertValuByUnit, convertValueByUnitData } from '@/utils/number';
import { getDateToString } from '@/utils/date';
import { isEmpty } from '@/utils/basic';


// TODO: 수정된 차트 색상 반영 필요.
// export const chartColorSet = ['#568bd2', '#7eca52', '#fd7484', '#409eff', '#636a98', '#9c68c8', '#efb754', '#53ad5f', '#26c7cd', '#999', '#ef9cd1'];
// export const chartOpacityColorSet = ['#568bd2', 'rgba(86, 139, 210, 0.6)', '#7eca52', 'rgba(126,202,82, 0.6)', '#fd7484', 'rgba(253, 116, 132, 0.6)'];
// export const chartColorSetBlack = ['#528fe0', '#79e440', '#Fb4e7c', '#73fafe', '#516097', '#a040f1', '#fdb537', '#38c74b', '#11d9e0', '#ddd', '#f55fbf'];
// export const chartOpacityColorSetBlack = ['#528fe0', 'rgba(82, 143, 224, 0.6)', '#79e440', 'rgba(121, 228, 64, 0.6)', '#Fb4e7c', 'rgba(251, 78, 124, 0.6)'];

export const chartColorSet = ['#5797fc', '#41cf3a', '#f76979', '#7b6df8', '#f6c320', '#d172ec', '#19cbc3', '#419b24', '#8a8599', '#ef9cd1'];
export const chartOpacityColorSet = ['#5797fc', 'rgba(87, 151, 252, 0.6)', '#41cf3a', 'rgba(65, 207, 58, 0.6)', '#f76979', 'rgba(247, 105, 121, 0.6)'];
export const chartColorSetBlack = ['#5797fc', '#4ecc48', '#ff6a6a', '#7e6fff', '#ffcc29', '#9559f4', '#9559f4', '#419b24', '#11d9e0', '#ddd', '#f55fbf'];
export const chartOpacityColorSetBlack = ['#5797fc', 'rgba(87, 151, 252, 0.6)', '#4ecc48', 'rgba(78, 204, 72, 0.6)', '#ff6a6a', 'rgba(255, 106, 106, 0.6)'];

export const lineOptions = {
  chart: {
    type: 'line',
    backgroundColor: 'transparent',
    spacingTop: 5,
    spacingBottom: 5,
  },
  title: false,
  credits: false,
  boost: {
    enabled: true,
    useGPUTranslations: true,
  },
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %Y-%m-%d %H:%M:%S}',
      style: {
        color: '$chinagray',
        fontSize: '9px',
      },
    },
    crosshair: true,
  },
  yAxis: {
    title: false,
    minTickInterval: 0,
    startOnTick: false,
    lineWidth: 2,
    labels: {
      formatter() {
        const series = this.chart.series;
        const unit = !isEmpty(series) && !isEmpty(series[0].userOptions.rscInfo) ? series[0].userOptions.rscInfo.rscUnit : null;
        return convertValuByUnit(this.value, unit, true, true);
      },
      style: {
        color: '$luckygray',
        fontSize: '9px',
      },
    },
  },
  plotOptions: {
    series: {
      animation: false,
      lineWidth: 2,
      marker: {
        radius: 2,
      },
    },
    // wordcloud: {
    //   style: {
    //     fontFamily: 'Lato',
    //   },
    // },
  },
  tooltip: {
    xDateFormat: '%Y-%m-%d %H:%M:%S',
    split: false,
    shared: true,
    valueDecimals: 2,
    formatter() {
      let tooltip = getDateToString(this.x, 'YYYY-MM-DD HH:mm:ss');
      this.points.forEach((point) => {
        const rscUnit = isEmpty(point.series.userOptions.rscInfo) ? null : point.series.userOptions.rscInfo.rscUnit;
        const yValue = rscUnit === 'count' ? convertValueByUnitData(point.y, 'count', '개', 1, null, null, true) : convertValuByUnit(point.y, rscUnit, true);
        tooltip += `<br/><span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${yValue}</b><br/>`;
      });
      return tooltip;
    },
  },
  legend: false,
  series: [],
  colors: chartColorSet,
};

export const stackedColumnOptions = {
  chart: {
    type: 'column',
    backgroundColor: 'transparent',
  },
  title: false,
  credits: false,
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %m-%d %H:%M}',
      style: {
        color: '$chinagray',
        fontSize: '9px',
      },
    },
  },
  yAxis: {
    title: false,
    min: 0,
  },
  time: {
    useUTC: false,
  },
  tooltip: {
    headerFormat: '<b>{point.key}</b><br/>',
    // xDateFormat: '%Y-%m-%d %H시',
    pointFormat: '{series.name}: {point.y}<br />',
    shared: true,
  },
  legend: false,
  plotOptions: {
    column: {
      stacking: 'normal',
    },
  },
  series: [],
  colors: chartColorSet,
};

export const areaOptions = {
  chart: {
    type: 'area',
    backgroundColor: 'transparent',
  },
  title: false,
  credits: false,
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %Y-%m-%d %H:%M:%S}',
    },
    crosshair: true,
  },
  yAxis: {
    title: false,
    min: 0,
  },
  plotOptions: {
    area: {
      fillOpacity: 0.3,
    },
    series: {
      animation: false,
      lineWidth: 2,
      marker: {
        radius: 2,
      },
    },
  },
  tooltip: {
    xDateFormat: '%Y-%m-%d %H:%M:%S',
    split: false,
    shared: true,
    valueDecimals: 2,
  },
  legend: false,
  series: [],
  colors: chartColorSet,
};

export const stackAreaOptions = {
  chart: {
    type: 'area',
    backgroundColor: 'transparent',
  },
  title: false,
  credits: false,
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %Y-%m-%d %H:%M}',
      style: {
        color: '$chinagray',
        fontSize: '9px',
      },
    },
    crosshair: true,
  },
  yAxis: {
    title: false,
    min: -1,
    startOnTick: false,
    lineWidth: 2,
    labels: {
      formatter() {
        const series = this.chart.series;
        const unit = !isEmpty(series) && !isEmpty(series[0].userOptions.rscInfo) ? series[0].userOptions.rscInfo.rscUnit : null;
        return convertValuByUnit(this.value, unit, true, true);
      },
      style: {
        color: '$luckygray',
        fontSize: '9px',
      },
    },
  },
  plotOptions: {
    area: {
      stacking: 'normal',
      fillOpacity: 0.5,
    },
    series: {
      animation: false,
      lineWidth: 1.5,
      marker: {
        radius: 2,
      },
    },
  },
  tooltip: {
    xDateFormat: '%Y-%m-%d %H:%M:%S',
    split: false,
    shared: true,
  },
  legend: false,
  series: [],
  colors: chartColorSet,
};

export const heatmapOptions = {
  chart: {
    type: 'heatmap',
    backgroundColor: 'transparent',
  },
  title: false,
  credits: false,
  xAxis: {
    categories: [],
  },
  yAxis: {
    categories: [],
    title: false,
  },
  colorAxis: {
    minColor: '#FFFFFF',
    maxColor: '#7CB5EC',
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        color: '#000000',
      },
    },
  },
  tooltip: {
    formatter() {
      return `<b>${this.series.xAxis.categories[this.point.x]}</b><br><b>결정계수 : ${this.point.value}</b><br><b>${this.series.yAxis.categories[this.point.y]}</b>`;
    },
  },
  series: [
    {
      borderWidth: 1,
      data: [],
    },
  ],
};

export const scatterOptions = {
  chart: {
    type: 'scatter',
    height: 250,
    backgroundColor: 'transparent',
  },
  boost: {
    enabled: true,
    useGPUTranslations: true,
  },
  time: {
    useUTC: false,
  },
  title: false,
  credits: false,
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %Y-%m-%d %H:%M}',
    },
  },
  yAxis: {
    title: false,
    minTickInterval: 1,
    startOnTick: false,
  },
  plotOptions: {
    series: {
      animation: false,
      marker: {
        radius: 5,
      },
    },
  },
  tooltip: {
    formatter() {
      return convertValuByUnit(this.y);
    },
  },
  legend: false,
  series: [],
  colors: ['rgba(124, 181, 236, 0.5)', 'rgba(223, 83, 83, 0.5)'],
};

export const columnOptions = {
  chart: {
    type: 'column',
    backgroundColor: 'transparent',
  },
  time: {
    useUTC: false,
  },
  title: false,
  credits: false,
  tooltip: {},
  xAxis: {
    labels: {
      style: {},
    },
  },
  yAxis: {
    title: false,
    min: 0,
    gridLineColor: '#e6e6e6',
    labels: {
      style: {},
    },
  },
  plotOptions: {},
  series: [],
  colors: chartColorSet,
};

export const columnEqOptions = {
  title: false,
  credits: false,
  legend: false,
  time: {
    useUTC: false,
  },
  boost: {
    enabled: false,
  },
  chart: {
    type: 'column',
    backgroundColor: 'transparent',
    spacingTop: 20,
    spacingBottom: 5,
  },
  xAxis: {
    visible: false,
    title: false,
    alignTick: false,
    startOnTick: false,
  },
  yAxis: {
    title: false,
    alignTick: false,
    startOnTick: false,
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: false,
        inside: true,
        distance: 30,
      },
    },
    column: {
      stacking: 'normal',
    },
  },
  series: [],
  colors: [],
  tooltip: {},
};

export const pieOptions = {
  chart: {
    type: 'pie',
    backgroundColor: 'transparent',
  },
  time: {
    useUTC: false,
  },
  title: false,
  credits: false,
  tooltip: {},
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
      showInLegend: true,
      innerSize: '60%',
    },
  },
  series: [],
  colors: chartColorSet,
};

// Yang - 더블 툴팁
export const doubleTootipLineOptions = {
  chart: {
    type: 'line',
    backgroundColor: 'transparent',
    spacingTop: 5,
    spacingBottom: 5,
  },
  title: false,
  credits: false,
  boost: {
    enabled: true,
    useGPUTranslations: true,
  },
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %Y-%m-%d %H:%M:%S}',
      style: {
        color: '$chinagray',
        fontSize: '9px',
      },
    },
    crosshair: true,
  },
  yAxis: {
    title: false,
    minTickInterval: 0,
    startOnTick: false,
    lineWidth: 1,
    labels: {
      formatter() {
        const series = this.chart.series;
        const unit = !isEmpty(series) && !isEmpty(series[0].userOptions.rscInfo) ? series[0].userOptions.rscInfo.rscUnit : null;
        return convertValuByUnit(this.value, unit, true, true);
      },
      style: {
        color: '$luckygray',
        fontSize: '9px',
      },
    },
  },
  plotOptions: {
    series: {
      animation: false,
      lineWidth: 2,
      marker: {
        radius: 2,
      },
    },
    // wordcloud: {
    //   style: {
    //     fontFamily: 'Lato',
    //   },
    // },
  },
  tooltip: {
    xDateFormat: '%Y-%m-%d %H:%M:%S',
    split: false,
    shared: true,
    valueDecimals: 2,
    useHTML: true,
    formatter() {
      const points = this.points;
      const time = getDateToString(points[0].x, 'YYYY-MM-DD HH:mm:ss');
      let max = 0;
      points.forEach((item) => {
        if (max < item.series.name.length) {
          max = item.series.name.length;
        }
      });
      max *= 14;
      let s = `<span style="font-size: 10px;">${time}</span><br/>`;
      for (let i = 0; i < points.length; i += 1) {
        const val = ceil(points[i].y, 2);
        s += `<span style="display:inline-block; width: ${max}px"><span style="color:${points[i].color}">●</span>${points[i].series.name}: <b>${val}</b></span>`;
        if (i % 2 === 1) {
          s += '<br/>';
        }
      }
      return s;
    },
  },
  legend: false,
  series: [],
  colors: chartColorSet,
};

export const barOptions = {
  chart: {
    type: 'bar',
    backgroundColor: 'transparent',
  },
  time: {
    useUTC: false,
  },
  title: false,
  credits: false,
  tooltip: {},
  xAxis: {
    labels: {
      style: {},
    },
  },
  yAxis: {
    title: false,
    min: 0,
    gridLineColor: '#e6e6e6',
    labels: {
      style: {},
    },
  },
  plotOptions: {},
  series: [],
  colors: chartColorSet,
};

export const multiLineOptions = {
  chart: {
    type: 'line',
    backgroundColor: 'transparent',
    spacingTop: 5,
    spacingBottom: 5,
  },
  title: false,
  credits: false,
  boost: {
    enabled: true,
    useGPUTranslations: true,
  },
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value: %Y-%m-%d %H:%M:%S}',
      style: {
        color: '$chinagray',
        fontSize: '9px',
      },
    },
    crosshair: true,
  },
  yAxis: [
    {
      title: false,
      minTickInterval: 0,
      startOnTick: false,
      lineWidth: 2,
      labels: {
        formatter() {
          const series = this.chart.series;
          const options = this.chart.options;
          const unit = !isEmpty(series) && !isEmpty(options.units.LEFT) ? options.units.LEFT[0].rscUnit : null;
          return convertValuByUnit(this.value, unit, true, true);
        },
        style: {
          color: '$luckygray',
          fontSize: '9px',
        },
      },
    },
    {
      title: false,
      minTickInterval: 0,
      startOnTick: false,
      lineWidth: 2,
      labels: {
        formatter() {
          const series = this.chart.series;
          const options = this.chart.options;
          const unit = !isEmpty(series) && !isEmpty(options.units.RIGHT) ? options.units.RIGHT[0].rscUnit : null;
          return convertValuByUnit(this.value, unit, true, true);
        },
        style: {
          color: '$luckygray',
          fontSize: '9px',
        },
      },
      opposite: true,
    },
  ],
  plotOptions: {
    series: {
      animation: false,
      lineWidth: 2,
      marker: {
        radius: 2,
      },
    },
  },
  tooltip: {
    xDateFormat: '%Y-%m-%d %H:%M:%S',
    split: false,
    shared: true,
    valueDecimals: 2,
    formatter() {
      let tooltip = getDateToString(this.x, 'YYYY-MM-DD HH:mm:ss');
      this.points.forEach((point) => {
        const rscUnit = isEmpty(point.series.userOptions.rscInfo) ? null : point.series.userOptions.rscInfo.rscUnit;
        const yValue = rscUnit === 'count' ? convertValueByUnitData(point.y, 'count', '개', 1, null, null, true) : convertValuByUnit(point.y, rscUnit, true);
        tooltip += `<br/><span style="color:${point.color}">\u25CF</span> ${point.series.name}: <b>${yValue}</b><br/>`;
      });
      return tooltip;
    },
  },
  legend: false,
  series: [],
  units: [],
  colors: chartColorSet,
};



// WEBPACK FOOTER //
// ./src/constants/chart-options.js